"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var overrides_1 = require("./overrides");
var utils_1 = require("@material-ui/utils");
exports.createOverrides = function (theme, overrides) {
    if (overrides === void 0) { overrides = {}; }
    var defaultOverrides = {
        MuiBackdrop: overrides_1.createMuiBackdropOverrides(theme),
        MuiButton: overrides_1.createMuiButtonOverrides(theme),
        MuiButtonGroup: overrides_1.createMuiButtonGroupOverrides(theme),
        MuiCheckbox: overrides_1.createMuiCheckboxOverrides(theme),
        MuiCircularProgress: overrides_1.createMuiCircularProgressOverrides(theme),
        MuiDialogActions: overrides_1.createMuiDialogActionsOverrides(theme),
        MuiDialogContent: overrides_1.createMuiDialogContentOverrides(theme),
        MuiDialogTitle: overrides_1.createMuiDialogTitleOverrides(theme),
        MuiFormControl: overrides_1.createMuiFormControlOverrides(theme),
        MuiFormControlLabel: overrides_1.createMuiFormControlLabelOverrides(theme),
        MuiFormHelperText: overrides_1.createMuiFormHelperTextOverrides(theme),
        MuiIconButton: overrides_1.createMuiIconButtonOverrides(theme),
        MuiInputAdornment: overrides_1.createMuiInputAdornmentOverrides(theme),
        MuiInputBase: overrides_1.createMuiInputBaseOverrides(theme),
        MuiInputLabel: overrides_1.createMuiInputLabelOverrides(theme),
        MuiLinearProgress: overrides_1.createMuiLinearProgressOverrides(theme),
        MuiLink: overrides_1.createMuiLinkOverrides(theme),
        MuiList: overrides_1.createMuiListOverrides(theme),
        MuiListItem: overrides_1.createMuiListItemOverrides(theme),
        MuiListItemSecondaryAction: overrides_1.createMuiListItemSecondaryActionOverrides(theme),
        MuiListItemText: overrides_1.createMuiListItemTextOverrides(theme),
        MuiMenu: overrides_1.createMuiMenuOverrides(theme),
        MuiMenuItem: overrides_1.createMuiMenuItemOverrides(theme),
        MuiOutlinedInput: overrides_1.createMuiOutlinedInputOverrides(theme),
        MuiRadio: overrides_1.createMuiRadioOverrides(theme),
        MuiSelect: overrides_1.createMuiSelectOverrides(theme),
        MuiSnackbarContent: overrides_1.createMuiSnackbarContentOverrides(theme),
        MuiSwitch: overrides_1.createMuiSwitchOverrides(theme),
        MuiTableBody: overrides_1.createMuiTableBodyOverrides(theme),
        MuiTableCell: overrides_1.createMuiTableCellOverrides(theme),
        MuiTableContainer: overrides_1.createMuiTableContainerOverrides(theme),
        MuiTableRow: overrides_1.createMuiTableRowOverrides(theme),
        MuiTableSortLabel: overrides_1.createMuiTableSortLabelOverrides(theme),
        MuiTooltip: overrides_1.createMuiTooltipOverrides(theme),
        MuiTypography: overrides_1.createMuiTypographyOverrides(theme),
    };
    return utils_1.deepmerge(defaultOverrides, overrides, { clone: false }); // no need to clone deep
};
//# sourceMappingURL=createOverrides.js.map